export const urls = {
	orders: {
		regions: '/sber_mq/region',
		externalForm: 'sber_mq/external_form',
		channel: '/channel',
	},
	cabinet: {
		inn: 'rbidos_request/inn',
	},
	landings: {
		leadCreate: '/lead/',
		agreementModel: '/agreement/by_key/sber_mq__external_form/main',
		offerList: '/sber_mq/sbercrm_list',
		createPartner: '/partner_registration_request',
		getCatalogCity: '/sber_mq/city',
		complete: '/lead/complete',
		refresh_sms: '/lead/refresh_sms',
		show: '/lead',
		selfEmployed: '/landing/self-employed',
		notary: '/landing/notary',
	},
	agreement: {
		description: '/agreement/:id',
		byKey: '/agreement/by_key/:parent_type/:kind',
		agreementUploadInfo: '/lead/extensions_for_notary_file',
		uploadInfo: '/lead/extensions_for_notary_file',
	},
}
